<template>
  <slot />
</template>

<script>
export default {
  name: 'AdminLoginLayout'
}
</script>

<style>
body {
  padding-bottom: unset !important;
}
</style>
